import Table, { ColumnsType } from "antd/es/table";
import { getCommentOfPostApi, getWalletHistoryApi } from "api/membership";
import CsTable from "components/Table";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppSelecter } from "redux/hook";
import { tokenSelect } from "redux/user/userSlice";
import styled from "styled-components";
import { MoneyConvert } from "utils/format";

const ViewBtn = styled.a`
  height: 28px;
  line-height: 28px;
  background-color: #000;
  color: #fff;
  border-radius: 4px;
  padding: 0 8px;
  cursor: pointer;
  display: inline-block;
`;

const statusMapping: any = {
  CAN_CANCEL: "결제완료",
  CANCEL_A_PART: "부분취소",
  CANCEL_ALL: "전체취소",
  DONE: "환불완료",
};

const WalletTable: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { userId } = useParams();
  // const token = useAppSelecter(tokenSelect);

  const [dataTable, setDataTable] = useState<{
    data: any;
    totalElement: number;
  }>({ data: [], totalElement: 0 });

  const getWalletHistory = async () => {
    if (!userId) return;
    const { data, error }: any = await getWalletHistoryApi({
      userId: +userId,
      page: Number(searchParams.get("page")) || 1,
      transactionType: "USING_VOUCHER",
      size: 10,
    });
    if (error) {
      console.error(error);
      return;
    }
    if (data.datas) {
      setDataTable({
        data: data.datas,
        totalElement: data?.pageable.totalElement,
      });
    }
  };
  // console.log(
  //   "process.env.REACT_APP_CLIENT_URL",
  //   process.env.REACT_APP_CLIENT_URL
  // );
  useEffect(() => {
    getWalletHistory();
  }, [searchParams.get("page")]);
  const columns: ColumnsType<any> = [
    {
      title: "결제 No.",
      dataIndex: "cl1",
      key: "cl1",
      width: "15%",
      render: (_, record) => <div>{record?.id}</div>,
    },
    {
      title: "결제일시",
      dataIndex: "cl2",
      key: "cl2",
      width: "21.25%",
      render: (_, record) => (
        <div>
          {dayjs(record?.createdTime).format("YYYY-MM-DD")}
          <br />
          {dayjs(record?.createdTime).format("HH:mm:ss")}
        </div>
      ),
    },
    {
      title: "결제-취소금액",
      dataIndex: "cl3",
      key: "cl3",
      width: "21.25%",
      render: (_, record) => (
        <div>{MoneyConvert(record?.amount - record?.cancelAmount, true)}</div>
      ),
    },
    {
      title: "브랜드명",
      dataIndex: "cl3",
      key: "cl3",
      width: "21.25%",
      render: (_, record) => <div>{record?.brandName}</div>,
    },
    {
      title: "결제상태",
      dataIndex: "cl3",
      key: "cl3",
      width: "21.25%",
      render: (_, record) => <div>{statusMapping[record?.refundStatus]}</div>,
    },
  ];
  return (
    <div>
      <Table
        // onChange={handleTableChange}
        bordered
        className="center-table"
        columns={columns}
        dataSource={dataTable.data}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: () => handleRowClick(record), // Click vào hàng
        //   };
        // }}
        pagination={
          dataTable.totalElement > 10
            ? {
                current: Number(searchParams.get("page")) || 1,
                total: dataTable.totalElement,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page) => {
                  searchParams.set("page", page.toString());
                  setSearchParams(searchParams);
                },
              }
            : false
        }
      />
    </div>
  );
};
export default WalletTable;
